
import { Button, Progress, Row, Select, Spin } from 'antd';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { ENV } from '../utils/http'
import { withRouter } from 'react-router-dom';
import styles from './newsletter.css';
import {
  changeNewsletter,
  fetchNewsletters,
  fetchWeeks,
  createNew,
  fetchStats,
  loadEmails,
  toggleSendDialog
} from './newsletterActions';

import NewsletterCreateModalComponent from './newsletterCreateModalComponent';
import NewsletterEmailModalComponent from './newsletterEmailModalComponent';
import NewsletterSendModalComponent from './newsletterSendModalComponent';

const Option = Select.Option;

class NewsletterComponent extends Component {

  componentDidMount() {
    if (this.props.list.length === 0) {
      this.props.dispatch(fetchWeeks());
    }

    this.interval = setInterval(() => this.reloadStats(), 5000);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  reloadStats() {

    if (this.props.showSendDialog) {
      return;
    }

    this.props.dispatch(fetchStats(this.props.newsletterId));
  }

  onWeekChange = (week) => {
    this.props.dispatch(fetchNewsletters(week));
  }

  onDatabaseChange = (newsletterId) => {
    let entry = this.props.newsletters.find( n => n.newsletterId === newsletterId);
    
    this.props.dispatch(changeNewsletter(newsletterId, entry.database, entry.published));
  }

  componentWillReceiveProps(nextProps) {

    if (nextProps.newsletterId !== this.props.newsletterId) {
      this.props.dispatch(fetchStats(nextProps.newsletterId));
    }

    if (nextProps.week && nextProps.newsletters.length === 0 && !nextProps.loading) {
      this.props.dispatch(fetchNewsletters(nextProps.week));
    }
  }

  editNewsletter() {
    this.props.history.push(`/nyhetsbrev/${this.props.newsletterId}`);
  }

  newNewsletter = () => {
    this.props.dispatch(createNew());
  }

  render() {

    if (!this.props.list) {
      return null;
    }

    return (<div>

      <NewsletterCreateModalComponent />
      <NewsletterEmailModalComponent />
      <NewsletterSendModalComponent />

      <Spin spinning={this.props.loading}>

        <Row style={styles.toolbar}>
          <Select value={this.props.week} onChange={this.onWeekChange}>
            {this.props.list.map((entry) => (<Option key={entry.id} value={entry.id}>{entry.name}</Option>))}
          </Select>
          {this.props.newsletterId > 0 && <Select value={this.props.newsletterId} onChange={(newletterId) => this.onDatabaseChange(newletterId)}>
            {this.props.newsletters.map((entry) => 
              (<Option key={entry.newsletterId} value={entry.newsletterId}>{entry.databaseName} {entry.isLegalLetter? ' - Lagbrev' : ''}</Option>))}
          </Select>}

          {(this.props.newsletterId > 0 ) &&
            <span style={{ fontSize: 18, marginLeft: 20 }}>
              ID: {this.props.newsletterId}
            </span>
          }

          <Button icon='mail' style={{ marginLeft: 10 }} onClick={() => this.props.dispatch(toggleSendDialog(true))} >Skicka</Button>
          <Button icon='plus' type='primary' size='large' onClick={this.newNewsletter} style={{ float: 'right' }}>Skapa nyhetsbrev</Button>
          <Button size='large' style={{ float: 'right', marginRight: 10 }} onClick={() => this.editNewsletter()} icon="edit" >Redigera</Button>

        </Row>

        {this.props.newsletterId > 0 && <div className='newsletter-wrapper' style={styles.newsletter}>
          {(this.props.notSentCount > 0 || this.props.sentCount > 0) &&
            <a href='#' onClick={() => this.props.dispatch(loadEmails(this.props.newsletterId))} style={styles.emailSentLabel}>
              Levererat till {this.props.sentCount} av {this.props.sentCount + this.props.notSentCount}
            </a>
          }

          {(this.props.notSentCount === 0 && this.props.sentCount === 0) &&
            <span style={{...styles.emailSentLabel, textDecoration:'none'}}>Ej skickat</span>
          }

          <div style={{...styles.publishLabel, background: this.props.published? '#4b4' : '#b22'}}>
           {this.props.published? 'Publicerat' : 'Ej publicerat'}
         </div>

          <iframe id="newsletter_preview" src={`${ENV.url}/nyhetsbrev/${this.props.newsletterId}/email/2`} style={styles.newsletterIFrame} frameBorder="0">
          </iframe>
        </div>}        

      </Spin>
    </div>)
  }
}

const mapStateToProps = (state) => {
  return {
    list: state.newsletter.list,
    week: state.newsletter.week,
    newsletters: state.newsletter.newsletters,
    loading: state.newsletter.loading,
    newsletterId: state.newsletter.newsletterId,
    notSentCount: state.newsletter.notSentCount,
    sentCount: state.newsletter.sentCount,
    showSendDialog: state.newsletter.showSendDialog,
    published: state.newsletter.published
  }
};

export default connect(mapStateToProps)(withRouter(NewsletterComponent));


// WEBPACK FOOTER //
// ./src/newsletter/newsletterComponent.js